import { render, staticRenderFns } from "./K3lAssessment.vue?vue&type=template&id=46ea445a&"
import script from "./K3lAssessment.vue?vue&type=script&lang=js&"
export * from "./K3lAssessment.vue?vue&type=script&lang=js&"
import style0 from "./K3lAssessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports